import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import PrintLabel from './printLabel';
import LineItemStatus from 'lineItemStatus';
import DropDownCell from 'components/LineItemTable/dropDownCell';
import InputCell from 'components/LineItemTable/inputCell';
import ItemEvents from 'components/LineItemTable/itemEvents';
import DatePicker from 'components/DatePicker';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import ItemNote from 'components/LineItemTable/itemNote';
import warehouseMerchandiseItem from 'types/warehouseMerchandiseItem';
import { purchaseOrderOptionsType } from 'types/purchaseOrder';
import { WAREHOUSE_MERCHANDISE_STATUSES, DISPLAY_DATE, RAILS_DATE } from 'config/constants';
import S from 'styles/table.scss';
import Editable from 'mixins/editable';


class WarehouseMerchandiseTableRow extends Editable(React.Component) {
  state = { ...this.props.lineItem };

  handleChange = key => (event) => {
    let value = null;
    if (['item_name', 'bin', 'note'].includes(key)) {
      value = event.target ? event.target.value : event;
      if (!value) value = '';
      // these characters stay in the code because we are catching them here,
      // not using them.
      value = value.replace(/[´‘’']/g, ' ft')
                   .replace(/[“”"]/g, ' in')
                   .replace(/[^\w\s]/gi, '');
    } else if (key === 'status') value = event.status;
    else if (key === 'date_received') value = moment(event).format(RAILS_DATE);
    else value = event.target ? event.target.value : event;
    this.setState({ [key]: value });
  }

  handleStatusChange = this.handleChange('status');
  handleDateChange = this.handleChange('date_received');
  handlePOChange = this.handleChange('purchase_order_id');
  handleItemNameChange = this.handleChange('item_name');
  handleReceivedQuantityChange = this.handleChange('received_quantity');
  handleBinChange = this.handleChange('bin');
  handleNoteChange = this.handleChange('note');

  handleStatusSave = lineItem => this.props.onSave(lineItem);

  handleSave = () => this.props.onSave(this.state);

  handleDelete = () => this.props.onDelete(this.state.id);

  renderStatusCell = () => {
    const options = WAREHOUSE_MERCHANDISE_STATUSES;
    const onChange = this.context.isEditable ? this.handleStatusChange : this.handleStatusSave;
    const lineItemStatusProps = { onChange, lineItem: this.state, options };
    const value = this.props.readOnly ? this.state.status :
      (<LineItemStatus {...lineItemStatusProps} />);
    return (<EditableTableCell onChange={onChange} label="Status" value={value} className={S.largeColumn}>
      {value}
    </EditableTableCell>);
  }

  renderTagNumber = () => {
    const value = (<div style={{ width: 92, position: 'relative' }}>
      {this.state.tag_number}
      <PrintLabel lineItem={this.state} padInfo={this.props.padInfo} />
    </div>);
    return (<EditableTableCell
      display={!this.context.isEditable}
      label="Tag #"
      value={value}
    />);
  }

  renderDateReceived = () => {
    const lineItem = this.state;
    const dateReceived = lineItem.date_received ? moment(lineItem.date_received).format(DISPLAY_DATE) : '';
    const onChange = this.handleDateChange;
    const value = (<DatePicker value={dateReceived} onChange={onChange} />);
    const cellProps = { label: 'Date Received', onChange, value: dateReceived, className: S.smallColumn };
    return (<EditableTableCell {...cellProps}>{value}</EditableTableCell>);
  }

  render = () => {
    const lineItem = this.state;
    const rowProps =
      { isNew: lineItem.id < 0, onSave: this.handleSave, onDelete: this.showDeleteDialog };
    return (<EditableTableRow key={lineItem.id} id={lineItem.id} {...rowProps}>
      <ItemEvents
        display={!this.context.isEditable}
        label=""
        itemType="warehouseMerchandiseItems"
        lineItem={lineItem}
        dataKeys={['po_number', 'item_name', 'received_quantity', 'tag_number', 'bin', 'date_received', 'status']}
      />
      <DropDownCell
        attr="purchase_order"
        isIdAttr
        label="PO Number"
        lineItem={lineItem}
        options={this.props.purchaseOrderOptions}
        cellValue={lineItem.po_number || ''}
        onChange={this.handlePOChange}
      />
      <InputCell attr="item_name" label="Item Name" lineItem={lineItem} onChange={this.handleItemNameChange} />
      <InputCell attr="received_quantity" label="QTY Received" lineItem={lineItem} onChange={this.handleReceivedQuantityChange} />
      {this.renderTagNumber()}
      <InputCell attr="bin" label="Bin" lineItem={lineItem} onChange={this.handleBinChange} />
      {this.renderDateReceived()}
      <ItemNote display label="Note" onChange={this.handleNoteChange} note={lineItem.note} errors={lineItem.errors} id={lineItem.id} />
      {this.renderStatusCell()}
    </EditableTableRow>);
  }
}

WarehouseMerchandiseTableRow.contextTypes = { isEditable: PropTypes.bool };

WarehouseMerchandiseTableRow.propTypes = {
  lineItem: PropTypes.shape(warehouseMerchandiseItem),
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  purchaseOrderOptions: purchaseOrderOptionsType,
  readOnly: PropTypes.bool,
  padInfo: PropTypes.arrayOf(PropTypes.shape({ cut_quantity: PropTypes.string })),
};

WarehouseMerchandiseTableRow.defaultProps = { lineItem: {} };

export default WarehouseMerchandiseTableRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/warehouseMerchandiseTableRow.jsx